<template>
  <component :is="getContainer" v-if="shouldRenderConfig"></component>
</template>
<script>
import { useWebproductStore } from "@/stores/modules/webproduct";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(useWebproductStore, ["getQuantitySelection"]),
    getContainer: function () {
      if (this.getQuantitySelection && this.getQuantitySelection != "") {
        return "appQuantitySelection";
      } else {
        return "appQuantityField";
      }
    }
  }
};
</script>
